import { FriendshipRepository } from '../repositories';
import { logger } from '@/src/core/utils';

export class RemoveFriendUseCase {
  constructor(private friendshipRepository: FriendshipRepository) {}

  async execute(friendshipId: string): Promise<void> {
    logger.debug('RemoveFriend', 'Removing friend', { friendshipId });

    await this.friendshipRepository.removeFriend(friendshipId);

    logger.debug('RemoveFriend', 'Successfully removed friend');
  }
}
